import { render, staticRenderFns } from "./UserData.vue?vue&type=template&id=f7610ee2&scoped=true&"
import script from "./UserData.vue?vue&type=script&lang=js&"
export * from "./UserData.vue?vue&type=script&lang=js&"
import style0 from "./UserData.vue?vue&type=style&index=0&id=f7610ee2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7610ee2",
  null
  
)

export default component.exports